'use client'

import { Fragment, Suspense } from 'react'
import { MobileBackButton } from '@/components/mobile-back-button'
import { Skeleton } from '@/components/skeleton'
import { RestaurantDetailContactSection } from '@/features/restaurants/restaurant-detail/restaurant-detail-contact/restaurant-detail-contact-section'
import { RestaurantDetailContentModalVisual } from '@/features/restaurants/restaurant-detail/restaurant-detail-content-modal-visual'
import { useRestaurantDetailContext } from '@/features/restaurants/restaurant-detail/restaurant-detail-context'
import { RestaurantDetailDeals } from '@/features/restaurants/restaurant-detail/restaurant-detail-deals'
import { RestaurantDetailHeader } from '@/features/restaurants/restaurant-detail/restaurant-detail-header'
import { RestaurantDetailVisualsContainer } from '@/features/restaurants/restaurant-detail/restaurant-detail-images/restaurant-detail-images-container'
import { RestaurantDetailLocationSection } from '@/features/restaurants/restaurant-detail/restaurant-detail-location/restaurant-detail-location-section'
import { RestaurantDetailMenu } from '@/features/restaurants/restaurant-detail/restaurant-detail-menu/restaurant-detail-menu'
import { RestaurantDetailNavigation } from '@/features/restaurants/restaurant-detail/restaurant-detail-navigation'
import { RestaurantDetailOpeningHoursSection } from '@/features/restaurants/restaurant-detail/restaurant-detail-opening-hours/restaurant-detail-opening-hours-section'
import { RestaurantDetailReviews } from '@/features/restaurants/restaurant-detail/restaurant-detail-reviews'
import { RestaurantDetailRewards } from '@/features/restaurants/restaurant-detail/restaurant-detail-rewards'
import { MobileBackButtonType } from '@/setup/back-button-init'

export const RestaurantDetailContent = () => {
    const { restaurant, citySlug } = useRestaurantDetailContext()

    if (!restaurant) return null

    return (
        <Fragment>
            <div className="flex flex-col items-center w-full relative">
                {citySlug && (
                    <MobileBackButton
                        type={MobileBackButtonType.RESTAURANT_DETAIL}
                        href={{ pattern: '/restaurants/[citySlug]', params: { citySlug } }}
                        className="absolute left-4 top-6 z-[1]"
                    />
                )}

                <RestaurantDetailVisualsContainer visuals={restaurant.visuals} />

                <div
                    className="flex flex-col items-center w-full relative md:sticky md:top-0 md:bg-white md:border-b-gray-300
                        md:border-b-[1px] mb-8 md:mb-12 md:z-[3] md:mt-0 mt-[-44px]"
                >
                    <div className="restaurant-detail-inner-container">
                        <div className="md:mt-10" />

                        <RestaurantDetailHeader />

                        <div className="md:mt-8" />

                        {/* Moving the item down by 1px to align it with the bottom border of the parents-parent container */}
                        <RestaurantDetailNavigation className="bottom-[-1px] hidden md:flex" />
                    </div>
                </div>

                <div className="restaurant-detail-inner-container pb-20">
                    <div className="md:mb-12w-full" />
                    <RestaurantDetailDeals />
                    <RestaurantDetailRewards />

                    <Suspense fallback={<Skeleton className="w-full h-20" />}>
                        <div className="w-full hidden md:block">
                            <RestaurantDetailMenu />
                        </div>

                        <RestaurantDetailOpeningHoursSection />

                        <RestaurantDetailLocationSection />
                        <RestaurantDetailContactSection />
                        <RestaurantDetailReviews />
                    </Suspense>
                </div>
            </div>

            <Suspense fallback={null}>
                <RestaurantDetailContentModalVisual restaurant={restaurant} citySlug={citySlug} />
            </Suspense>
        </Fragment>
    )
}
